// eslint-disable-next-line import/no-cycle
import Listing from '../purchase-request/Listing';

const UsersList = () => {
  return <Listing type="users" />;
};

export default UsersList;
